import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
}
const routes = [
  {
    path: '/',
    redirect: 'Layout'
  },
  {
    path: '/Layout',
    name: 'Layout',
    component: () => import('@/components/Layout.vue'),
    redirect: 'Home',
    children: [
      {
        path: '/Home',
        name: 'Home',
        meta: {
          title: '首页'
        },
        component: () => import('@/views/Home.vue'),
      },
      {
        path: '/News',
        name: 'News',
        meta: {
          title: '新闻动态'
        },
        component: () => import('@/views/News.vue'),
        children: [
          {
            path: '/newsone',
            component: () => import('@/views/new/newsone.vue')
          }
        ]
      },
      {
        path: '/Product',
        name: 'Product',
        meta: {
          title: '产品'
        },
        component: () => import('@/views/Product.vue'),
      },
      {
        path: '/Productlist',
        name: 'Productlist',
        meta: {
          title: '产品中心'
        },
        component: () => import('@/views/Productlist.vue'),
      },
      {
        path: '/Solve',
        name: 'Solve',
        meta: {
          title: '解决方案'
        },
        component: () => import('@/views/Solve.vue'),
      },

      {
        path: '/Case',
        name: 'Case',
        meta: {
          title: '案例展示'
        },
        component: () => import('@/views/Case.vue'),
      },
      {
        path: '/About',
        name: 'About',
        meta: {
          title: '关于我们'
        },
        component: () => import('@/views/About.vue'),
      },
      {
        path: '/cjz',
        name: 'cjz',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/cjz.vue'),
      },
      {
        path: '/cwg',
        name: 'cwg',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/cwg.vue'),
      },
      {
        path: '/dc',
        name: 'dc',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/dc.vue'),
      },
      {
        path: '/dl',
        name: 'dl',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/dl.vue'),
      },
      {
        path: '/kly',
        name: 'kly',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/kly.vue'),
      },
      {
        path: '/qxz',
        name: 'qxz',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/qxz.vue'),
      },
      {
        path: '/rlcj',
        name: 'rlcj',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/rlcj.vue'),
      },
      {
        path: '/sgcs',
        name: 'sgcs',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/sgcs.vue'),
      },
      {
        path: '/tct',
        name: 'tct',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/tct.vue'),
      },
      {
        path: '/tqq',
        name: 'tqq',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/tqq.vue'),
      },
      {
        path: '/tscs',
        name: 'tscs',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/tscs.vue'),
      },
      {
        path: '/tycs',
        name: 'tycs',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/tycs.vue'),
      },
      {
        path: '/ytj',
        name: 'ytj',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/ytj.vue'),
      },
      {
        path: '/ytxs',
        name: 'ytxs',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/ytxs.vue'),
      },
      {
        path: '/ywqc',
        name: 'ywqc',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/ywqc.vue'),
      },
      {
        path: '/zsp',
        name: 'zsp',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/zsp.vue'),
      },
      {
        path: '/Trail',
        name: 'Trail',
        meta: {
          title: '采集柱'
        },
        component: () => import('@/views/Trail.vue'),
      }
    ]
  }
]

const router = new VueRouter({
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
